import { Injectable } from '@angular/core';
import { HttpErrorRoot } from '../models/common/http-error.model';
import { ToastService } from '../shared-new/services/toast.service';

@Injectable({
  providedIn: 'root',
})
export class HttpErrorHandlerService {

  public constructor(private toastService: ToastService) { }

  public ShowErrorMessage(
    httpError: HttpErrorRoot,
    messageTitle: string = 'Error'
  ) {
    if (httpError && httpError.status !== 200 && httpError.error?.length > 0) {
      // not ok
      if (typeof httpError.error === 'string') {
        this.toastService.error(httpError.error, messageTitle);
      }
      else {
        this.toastService.error(
          httpError.error.map((m) => m.message).join('\n\r'),
          messageTitle
        );
      }
    }
  }
  public ShowCustomErrorMessage(
    httpError: any, // change to any for flexibility
    messageTitle: string = 'Error'
  ) {
    if (httpError?.status !== 200) {
      if (typeof httpError?.error === 'string') {
        this.toastService.error(httpError.error, messageTitle);
      } else if (Array.isArray(httpError?.error)) {
        this.toastService.error(
          httpError.error.map((m: { message: any; }) => m.message).join('\n\r'),
          messageTitle
        );
      } else if (httpError?.message) {
        this.toastService.error(httpError.message, messageTitle);
      } else {
        this.toastService.error('An unknown error occurred', messageTitle);
      }
    }
  }


  ShowWarning(message: string, title: string, autoHide: boolean = true) {
    this.toastService.warning(message, title, autoHide);
  }
  ShowInformation(message: string, title: string) {
    this.toastService.info(message, title);
  }
}
